'use strict';

var q = require('q');
var axios = require('axios/dist/axios').default;

var baseConfig = {
  withCredentials: true,
  validateStatus: function (status) {
    return true;
  },
};

var sendAction = {
  get: function get(uri) {
    return q(axios(uri, Object.assign(baseConfig, {
      method: 'GET',
    })).then(adaptResponse));
  },

  post: function post(uri, data) {
    return q(axios(uri, Object.assign(baseConfig, {
      method: 'POST',
      data,
    })).then(adaptResponse));
  },

  put: function put(uri, data) {
    return q(axios(uri, Object.assign(baseConfig, {
      method: 'PUT',
      data,
    })).then(adaptResponse));
  },

  patch: function patch(uri, data) {
    return q(axios(uri, Object.assign(baseConfig, {
      method: 'PATCH',
      data,
    })).then(adaptResponse));
  },
  delete: function get(uri) {
    return q(axios(uri, Object.assign(baseConfig, {
      method: 'DELETE',
    })).then(adaptResponse));
  },
};

function adaptResponse(response) {
  var {data, status, statusText} = response;
  checkError(response);

  var responseText = JSON.stringify(data);
  return {
    text: responseText,
    body: data,
    xhr: Object.assign(response, {
      responseText
    }),
  };
}

function checkError(response) {
  var {data, status, statusText} = response;
  var responseText = JSON.stringify(data);
  if(status >= 400) {
    throw {
      error: new Error(statusText),
      response: {
        text: responseText,
        body: data,
        xhr: Object.assign(response, {
          status, 
          statusText
        })
      }
    };
  }
}

module.exports = sendAction;
